export const gray = "#F8F8F8";
export const darkGray = "#E3E3E3";
export const black = "#222222";
export const lightGray = "#B2B2B2";
export const textBlack = "#000000";
export const white = "#FFFFFF";
export const darkBlack = "#202020";
